import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/index/index'
import search from '@/pages/search/search'
import business from '@/pages/business/business';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/business',
      name: 'business',
      component: business
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js